<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="marcacao || guia">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Alterar Profissional
                            <span v-if="marcacao && marcacao.id_atendimento" class="badge badge-secondary ml-2">#{{ marcacao.id_atendimento }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!lista || !lista.length" />

                        <div v-else>

                            <template v-if="outros_parms && outros_parms.alt_proc">
                                <div v-if="marcacao.procedimento" class="alert alert-info d-flex justify-content-between">
                                    {{ marcacao.procedimento.search }}
                                </div>
                            </template>

                            <az-input 
                                v-if="pode_por_medico && altera_medico_item"
                                type="button-group"
                                :optionsList="[
                                    { id: 'E', search: 'Apenas do Exame' },
                                    { id: 'A', search: 'Exames do Atendimento' },
                                ]"
                                v-model="escopo" />

                            <template v-else-if="1==0 && !guia && marcacao && marcacao.id_atendimento && marcacao.plano && ( marcacao.plano.id_operadora != 1 ) && ( $store.state.user.id_usuario == 1 )">
                                <az-input 
                                    type="checkbox-group"
                                    label="Manter profissional original na guia"
                                    v-model="manter_guia" />
                            </template>

                            <az-input
                                icon="fa fa-search fa-fw"
                                placeholder="Pesquisar..."
                                v-model="search" />

                            <div class="list-group">
                                <button type="button" class="list-group-item list-group-item-action" v-for="(item, idx) in exibicao" :key="idx"
                                    @click="atualizar(item.medico_unidade.medico)">
                                    {{ item.medico_unidade.medico.search }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data () { 
        return { 
            lista: null, 
            marcacao: null,
            search: "",  
            guia: null, 
            escopo: 'E', 
            outros_parms: null, 
            altera_medico_item: false, 
            callback_refresh: null,
            id_procedimento_alter: null, 
            modal_chave: "", 
            manter_guia: false,
        }
    },

    components: { 
        AzEmptyState,
        AzInput,  
    },

    computed: { 
        exibicao: function () { 
            if ( !this.lista )
                return [];

            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.lista.filter (item => !this.search || reg.test(JSON.stringify(item)));
        },

        modal_name: function () { 
            return `alterarProfissionalModal${this.modal_chave}`;
        },
    },

    props: ['pode_por_medico'], 

    methods: { 
        alterar_guia (guia) { 

            this.callback_refresh = null; 

            this.search = "";
            this.lista = null;
            this.manter_guia = false;
            this.guia = guia;
            this.$store.commit('loading', true);

            $('#' + this.modal_name).modal('show');

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'lista_alterar_profissional',
                parms: { 
                    id_guia: guia.id_guia,
                }
            })
            .then(res => { 
                if ( !res ) { 
                    $('#' + this.modal_name).modal('hide');
                    return;
                }

                if ( !res.trocar ) { 
                    $('#' + this.modal_name).modal('hide');
                    return;
                } 

                this.lista = res.lista;
            })
            .finally(() => { 
               this.$store.commit('loading', false); 
            });

        },

        alterar(marcacao, callback_remarcar, outros_parms = {}, callback_refresh = null) { 
            this.search = "";
            this.lista = null;
            this.manter_guia = false;
            this.marcacao = marcacao;
            this.outros_parms = outros_parms;
            this.callback_refresh = callback_refresh; 
            this.$store.commit('loading', true);

            $('#' + this.modal_name).modal('show');

            this.$util.loadItem(this, { 
                service: 'marcacoes',
                func: 'lista_alterar_profissional',
                parms: { 
                    id_marcacao: marcacao.id_marcacao,
                    ...outros_parms, 
                }
            })
            .then(res => { 
                if ( !res ) { 
                    $('#' + this.modal_name).modal('hide');
                    return;
                }

                if ( !res.trocar ) { 
                    $('#' + this.modal_name).modal('hide');
                    callback_remarcar();
                    return;
                } 

                this.lista = res.lista;
                this.altera_medico_item = this.pode_por_medico && res.laudo_alterar_medico_item;
                this.id_procedimento_alter = res.id_procedimento_1;
            })
            .finally(() => { 
               this.$store.commit('loading', false); 
            });
        },

        atualizar(medico) { 

            if ( this.guia ) { 
                this.$util.atualizar(this, { 
                    service: 'guias',
                    func: 'alterar_profissional',
                    dados: { 
                        id_guia: this.guia.id_guia,
                        id_medico: medico.id_pessoa,
                    },
                    toast: true,
                    modal: this.modal_name,
                    callback: () => { 
                        this.$emit('refresh');

                        if ( this.callback_refresh ) { 
                            this.callback_refresh();
                        }
                    }
                });

                return;
            }

            this.$util.atualizar(this, { 
                service: 'marcacoes',
                func: 'alterar_profissional',
                dados: { 
                    id_marcacao: this.marcacao.id_marcacao,
                    id_medico: medico.id_pessoa,
                    escopo: ( this.pode_por_medico && this.altera_medico_item ) ? this.escopo : null,
                    ...( this.outros_parms ? this.outros_parms : {} ),  
                },
                toast: true,
                modal: this.modal_name,
                callback: () => { 
                    this.$emit('refresh');

                    if ( this.callback_refresh ) { 
                        this.callback_refresh();
                    }
                }
            });
            
        }
    },

    mounted() { 
        this.modal_chave = this.$util.uuidv4();
    }

}
</script>